export enum BaseAppReduxActions {
  BASE_APP_MENU_LIST = 'BASE_APP_MENU_LIST',
  BASE_APP_SET_THEME = 'BASE_APP_SET_THEME',
  BASE_APP_SET_DEFAULT_THEME = 'BASE_APP_SET_DEFAULT_THEME',
  BASE_APP_SET_CSS_THEME = 'BASE_APP_SET_CSS_THEME',
  BASE_APP_SET_SIDEBAR_DASHBOARD_THEME = 'BASE_APP_SET_SIDEBAR_DASHBOARD_THEME',
  BASE_APP_SET_SIDEBAR_PACKET_THEME = 'BASE_APP_SET_SIDEBAR_PACKET_THEME',
  BASE_APP_SET_SIDEBAR_DASHBOARD_THEME_FROM_INTERCEPTOR = 'BASE_APP_SET_SIDEBAR_DASHBOARD_THEME_FROM_INTERCEPTOR',
  BASE_APP_SET_SIDEBAR_DASHBOARD_THEME_RESET = 'BASE_APP_SET_SIDEBAR_DASHBOARD_THEME_RESET',
  BASE_APP_SET_SIDEBAR_DASHBOARD_THEME_LOGIN = 'BASE_APP_SET_SIDEBAR_DASHBOARD_THEME_LOGIN',
  BASE_APP_SET_FETCH_TEMPLATE = 'BASE_APP_SET_FETCH_TEMPLATE',
  BASE_APP_ORGS_LIST = 'BASE_APP_ORGS_LIST',
  BASE_APP_SET_ACTIVE_ORG = 'BASE_APP_SET_ACTIVE_ORG',
  BASE_APP_ORGS_ACL_CONFIG = 'BASE_APP_ORGS_ACL_CONFIG',
}

const setOrgsList = (payload: any): any => ({
  type: BaseAppReduxActions.BASE_APP_ORGS_LIST,
  payload,
});

const setActiveOrg = (payload: any): any => ({
  type: BaseAppReduxActions.BASE_APP_SET_ACTIVE_ORG,
  payload,
});

export const setSidebarFetchTemplate = (payload: any): any => ({
  type: BaseAppReduxActions.BASE_APP_SET_FETCH_TEMPLATE,
  payload,
});
export const setSidebarDashboard = (payload: any): any => ({
  type: BaseAppReduxActions.BASE_APP_SET_SIDEBAR_DASHBOARD_THEME,
  payload,
});
export const setSidebarDashboardFromInterceptor = (payload: any): any => ({
  type: BaseAppReduxActions.BASE_APP_SET_SIDEBAR_DASHBOARD_THEME_FROM_INTERCEPTOR,
  payload,
});

export const resetSidebarDashboardTheme = (payload: any): any => ({
  type: BaseAppReduxActions.BASE_APP_SET_SIDEBAR_DASHBOARD_THEME_RESET,
  payload,
});

export const setSidebarDashboardThemeLoggedIn = (payload: any): any => ({
  type: BaseAppReduxActions.BASE_APP_SET_SIDEBAR_DASHBOARD_THEME_LOGIN,
  payload,
});

export const setSidebarPacket = (payload: any): any => ({
  type: BaseAppReduxActions.BASE_APP_SET_SIDEBAR_PACKET_THEME,
  payload,
});

const setMenuList = (payload: any): any => ({
  type: BaseAppReduxActions.BASE_APP_MENU_LIST,
  payload,
});

const setAppTheme = (payload: any): any => ({
  type: BaseAppReduxActions.BASE_APP_SET_THEME,
  payload,
});

const setDefaultTheme = (payload: any): any => ({
  type: BaseAppReduxActions.BASE_APP_SET_DEFAULT_THEME,
  payload,
});

const setCSSTheme = (payload: any): any => ({
  type: BaseAppReduxActions.BASE_APP_SET_CSS_THEME,
  payload,
});
const setOrgAclConfig = (payload: any): any => ({
  type: BaseAppReduxActions.BASE_APP_ORGS_ACL_CONFIG,
  payload,
});

export const BaseAppActions = {
  setSidebarFetchTemplate,
  resetSidebarDashboardTheme,
  setSidebarDashboardFromInterceptor,
  setSidebarDashboardThemeLoggedIn,
  setSidebarDashboard,
  setSidebarPacket,
  setMenuList,
  setAppTheme,
  setDefaultTheme,
  setCSSTheme,
  setOrgsList,
  setActiveOrg,
  setOrgAclConfig,
};
